import React from 'react';
import Reveal from './Reveal';
import IconBadge from './IconBadge';
import CircuitDivider from './CircuitDivider';
import SectionHeader from './SectionHeader';
import EditableText from './EditableText';
import { resolveHomeIcon } from '../lib/homeIcons';

/** Ligne pointillée entre les 3 badges (lg+) — centrée sur les colonnes. */
const StepConnector = () => (
  <div
    className="pointer-events-none absolute left-[16.67%] right-[16.67%] top-8 hidden h-0 lg:block"
    aria-hidden="true"
  >
    <svg
      className="absolute inset-x-0 top-0 h-3 w-full -translate-y-1/2 overflow-visible"
      viewBox="0 0 800 12"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 6 H800"
        stroke="url(#how-step-gradient)"
        strokeWidth="1.25"
        strokeDasharray="5 7"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient id="how-step-gradient" x1="0" y1="0" x2="800" y2="0">
          <stop stopColor="#3a00e0" stopOpacity="0.35" />
          <stop offset="0.5" stopColor="#fab03a" stopOpacity="0.5" />
          <stop offset="1" stopColor="#3a00e0" stopOpacity="0.35" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

const HowItWorks = ({ steps }) => (
  <section className="section-y px-4 relative overflow-hidden bg-white">
    <div
      className="absolute top-0 right-0 w-72 h-72 opacity-[0.04] pointer-events-none"
      aria-hidden="true"
    >
      <svg viewBox="0 0 200 200" fill="none" className="w-full h-full">
        <circle cx="100" cy="100" r="80" stroke="#3a00e0" strokeWidth="1" />
        <circle cx="100" cy="100" r="50" stroke="#fab03a" strokeWidth="1" />
      </svg>
    </div>

    <div className="max-w-7xl mx-auto relative">
      <SectionHeader
        eyebrow="Simple et efficace"
        eyebrowKey="home.how.eyebrow"
        title="Comment ça marche ?"
        titleKey="home.how.title"
        subtitle="Trois étapes pour apprendre la robotique en s'amusant — montage, code et compréhension."
        subtitleKey="home.how.subtitle"
        reveal
      />

      <div className="relative">
        <StepConnector />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
          {steps.map((step, i) => {
            const StepIcon = resolveHomeIcon(step.icon);
            const n = i + 1;
            return (
              <Reveal key={step.title} animation="fade-up" delay={i * 70}>
                <div className="relative text-center">
                  <div className="flex flex-col items-center">
                    <div className="relative mb-5">
                      <IconBadge
                        icon={StepIcon}
                        variant={i % 2 === 0 ? 'purple' : 'orange'}
                        size="lg"
                      />
                      <span
                        className={`absolute -top-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-white text-xs font-bold shadow-sm border ${
                          i % 2 === 0
                            ? 'border-[rgba(58,0,224,0.22)] text-[#3a00e0]'
                            : 'border-[rgba(250,176,58,0.45)] text-[#c47a0a]'
                        }`}
                      >
                        {step.number}
                      </span>
                    </div>
                    <EditableText
                      editKey={`home.how.${n}.title`}
                      defaultValue={step.title}
                      as="h3"
                      className="text-slate-900 font-semibold text-lg mb-2"
                    />
                    <EditableText
                      editKey={`home.how.${n}.text`}
                      defaultValue={step.description}
                      as="p"
                      multiline
                      className="text-slate-600 text-sm leading-relaxed max-w-xs mx-auto"
                    />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>

    <CircuitDivider className="mt-14 mb-0" />
  </section>
);

export default HowItWorks;
